<template>
    <div>
        <div class="action-header my-4">
            <h1 class="header">{{this.$vuetify.lang.t('$vuetify.employee.employeeManagement')}}</h1>
            <v-btn
                height="40px"
                color="primary"
                @click="importFace()">
                {{this.$vuetify.lang.t('$vuetify.employee.importFaceImage')}}
            </v-btn>
        </div>
        <div class="action-header">
            <div class="search-container">
                <div class="search-input">
                    <v-text-field
                        v-model="search"
                        prepend-inner-icon="search"
                        :placeholder="this.$vuetify.lang.t('$vuetify.employee.searchText')"
                        outlined
                        height="40px"
                        dense
                        @keyup.enter="searchEmployee()"
                        background-color="#ffffff">
                    </v-text-field>

                    <div class="ml-3">
                        <v-btn
                            height="40px"
                            color="primary"
                            outlined
                            @click="searchEmployee()">
                            {{ $vuetify.lang.t('$vuetify.employee.search') }}
                        </v-btn>
                    </div>
                </div>

                <div class="filter-input">
                    <div class="status-filter">
                        <v-select
                            @change="searchEmployee()"
                            v-model="employeeStatusFilter"
                            :items="statusList"
                            item-text="text"
                            item-value="value"
                            outlined
                            dense
                            height="40"
                            background-color="#ffffff">
                        </v-select>
                    </div>
                    <div class="ml-5 status-filter">
                        <v-select
                            @change="searchEmployee()"
                            v-model="employeeFaceFilter"
                            :items="employeeFaceDropDown"
                            item-text="text"
                            item-value="value"
                            outlined
                            dense
                            height="40"
                            background-color="#ffffff">
                        </v-select>
                    </div>
                    <div class="ml-5 status-filter-bureau">
                        <v-autocomplete
                            @change="searchEmployee()"
                            v-model="employeeBureauFilter"
                            :items="bureauList"
                            dense
                            height="40"
                            outlined
                            background-color="#ffffff"
                        ></v-autocomplete>
                    </div>
                </div>

            </div>
        </div>
        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :options.sync="options"
                :server-items-length="totalEmployee"
                :items="employees"
                :loading="loading">
                <template v-slot:[`item.status`]="{ item }">
                    <div>
                        <span :class="statusStyle(item.status)">{{item.status}}</span>
                    </div>
                </template>
                <template v-slot:[`item.line`]="{ item }">
                    <div class="line">
                        <img
                            @click="lineRegisCodeModal(item.id)"
                            class="mr-2 line-hover"
                            width="24"
                            src="@/assets/line-logo.png"/>
                    </div>
                </template>
                <template v-slot:[`item.has_face`]="{ item }">
                    <v-icon
                        v-if="item.has_face"
                        color="#6c98ba"
                        >
                        mdi-checkbox-marked-circle
                    </v-icon>
                    <v-icon
                        v-else
                        color="#ff544a"
                        >
                        mdi-close-circle
                    </v-icon>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                    <div class="action" v-if="canUpdate">
                        <i
                            class="pointer far fa-edit mr-3"
                            @click="editEmployee(item.id)">
                        </i>
                        <i
                            class="pointer far fa-trash-alt"
                            @click="openDeleteModal(item)">
                        </i>
                    </div>
                </template>
            </v-data-table>
        </v-card>
        <div class="pt-2 paginator-box">
            <div>
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </div>
        <line-regis-code-modal
            ref="lineRegisCodeModal" />
        <delete-modal
            ref="modalDelete"
            @success-deleted="deleteSuccess()"
            :deleteForm="deleteForm"/>
    </div>
</template>

<script>
import LineRegisCodeModal from '@/components/modal/LineRegisCodeModal'
import DeleteModal from '@/components/modal/DeleteModal.vue'
export default {
    name: 'Employees',

    components: {
        LineRegisCodeModal,
        DeleteModal
    },

    data () {
        return {
            search: '',
            pageCount: 1,
            page: 1,
            options: {},
            loading: false,
            totalEmployee: 0,
            employees: [],
            employeeFaceFilter: null,
            employeeStatusFilter: null,
            employeeBureauFilter: null,
            statusList: [],
            bureauList: [],
            deleteForm: {
                header: '',
                content: '',
                path: ''
            },
            canUpdate: false
        }
    },

    computed: {
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.employee.employeeId'), value: 'employee_id', width: '10%' },
                { text: this.$vuetify.lang.t('$vuetify.employee.employeeName'), value: 'fullname', width: '20%' },
                { text: this.$vuetify.lang.t('$vuetify.employee.bureauAcronym'), value: 'organization__short_name', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.employee.positionAcronym'), value: 'position__short_name', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.employee.status'), value: 'status', width: '10%' },
                { text: this.$vuetify.lang.t('$vuetify.employee.line'), value: 'line', width: '5%', align: 'center', sortable: false },
                { text: this.$vuetify.lang.t('$vuetify.employee.hasFace'), value: 'has_face', align: 'center', width: '8%' },
                { text: this.$vuetify.lang.t('$vuetify.employee.action'), value: 'action', align: 'center', width: '7%', sortable: false }
            ]
        },

        employeeFaceDropDown () {
            return [{
                text: this.$vuetify.lang.t('$vuetify.employee.allFaceStatus'),
                value: null
            }, {
                text: this.$vuetify.lang.t('$vuetify.employee.validFaceImage'),
                value: true
            }, {
                text: this.$vuetify.lang.t('$vuetify.employee.inValidFaceImage'),
                value: false
            }]
        }
    },

    methods: {
        statusStyle (status) {
            if (status === 'Deactive' || status === 'ปิดการใช้งาน') {
                return 'inactive-status-text'
            }
        },

        async searchEmployee () {
            this.options.page = 1
            await this.getEmployees()
        },

        async getEmployees () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `employees?page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            if (this.employeeFaceFilter !== null) {
                url += `&hasFace=${this.employeeFaceFilter}`
            }

            if (this.employeeStatusFilter) {
                url += `&status=${this.employeeStatusFilter}`
            }
            if (this.employeeBureauFilter) {
                url += `&bureau=${this.employeeBureauFilter}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.employees = res.data.data
                this.totalEmployee = res.data.total
                this.loading = false
            }
        },

        async getStatus () {
            const res = await this.axios.get('employee/status')
            if (res && res.data && res.data.status === 'ok') {
                this.statusList = res.data.data
            }
        },

        async getBureaus () {
            const res = await this.axios.get('bureau/options')
            if (res && res.data && res.data.status === 'ok') {
                this.bureauList = res.data.data
            }
        },

        editEmployee (id) {
            this.$router.push({ name: 'EmployeeInfo', params: { id } }, () => {})
        },

        async lineRegisCodeModal (id) {
            this.$refs.lineRegisCodeModal.openModal(id)
        },

        importFace () {
            this.$router.push({ name: 'EmployeeImport' }, () => {})
        },

        openDeleteModal (item) {
            this.deleteForm.header = this.$vuetify.lang.t('$vuetify.employee.deleteEmployee')
            this.deleteForm.content = `${this.$vuetify.lang.t('$vuetify.employee.areYouSureToDeleteEmployee')} ${item.fullname} ?`
            this.deleteForm.path = `employee/delete/${item.id}`
            this.$refs.modalDelete.dialog = true
        },

        async deleteSuccess () {
            await this.getEmployees()
            this.$notify({
                title: this.$vuetify.lang.t('$vuetify.employee.updated'),
                text: this.$vuetify.lang.t('$vuetify.employee.employeeIsDeleted'),
                type: 'success'
            })
        }
    },

    async mounted () {
        this.canUpdate = await this.hasPermission(this.$constant.permission.EMPLOYEE_MANAGEMENT.UPDATE)
        await this.getStatus()
        await this.getBureaus()
        await this.getEmployees()
    },

    watch: {
        options: {
            async handler () {
                await this.getEmployees()
            },
            deep: true
        },
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                await this.getStatus()
                await this.getBureaus()
                await this.getEmployees()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.status-filter {
    width: 160px;
}
.status-filter-bureau {
    width: 300px;
}
.inactive-status-text {
    color: #ff544a;
}
.line {
    cursor: pointer;
}
::v-deep div[class*="status-filter"] .v-select__selection {
    line-height: 1.75;
}
</style>
